import { render } from "./wokerDetail17.vue?vue&type=template&id=1ba4dd5e&scoped=true"
import script from "./wokerDetail17.vue?vue&type=script&lang=js"
export * from "./wokerDetail17.vue?vue&type=script&lang=js"

import "./wokerDetail17.vue?vue&type=style&index=0&id=1ba4dd5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba4dd5e"]])

export default __exports__